import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAR = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.806 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M25 0C15.087 0 6.523 5.768 2.48 14.13h45.038C43.475 5.768 34.911 0 25 0ZM25 50c9.91 0 18.475-5.768 22.519-14.13H2.48C6.524 44.232 15.088 50 25 50Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m32.471 25-3.053 1.436 1.626 2.957-3.315-.634-.42 3.349-2.31-2.463-2.309 2.463-.42-3.35-3.315.635 1.625-2.957L17.527 25l3.053-1.436-1.625-2.957 3.315.634.42-3.35L25 20.356l2.309-2.463.42 3.35 3.315-.635-1.626 2.957L32.471 25Z"
}));
FlagAR.displayName = 'FlagAR';
export default withFlagWrapper(FlagAR);
//# sourceMappingURL=index.js.map